import {Card} from '@material-ui/core';
import React, {useContext} from 'react';
import DmFilterTabs from './tabs';
import {ThemeContext} from '../../../../themes/ThemeProvider';

const DataManagerFilter = () => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  return (
    <>
      <Card className={` ${classes.cardBordernoneStyles} mb-0`} elevation={0}>
        <DmFilterTabs />
      </Card>
    </>
  );
};

export default DataManagerFilter;
